import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_workers_reimbursed_recruitment_fees_related_costs_paid'

export const dataPointDefinition = {
  retracedId: 'are_workers_reimbursed_recruitment_fees_related_costs_paid',
  name: 'Are workers reimbursed for recruitment fees and related costs paid?',
  description:
    'The intent of this question is to understand if the facility or any other party reimburses workers for recruitment fees and related costs they may have paid during the recruitment process. ',
  meta: {
    slcpMeta: {
      key: 'fl-4--4',
      number: 'RH-REC-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fl-4--4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27170,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
